<template>
  <div class="payForMe">
      <!-- 顶部用户信息 -->
    <div class="top-con">
        <div class="user-img">
            <img :src="datas.userHeadImg" alt="">
        </div>
        <div class="user-message">
            <div class="user-nickName-phone">
                <div class="nickName">{{datas.userName}}</div>
                <div class="phone">({{userPhone}})</div>
            </div>
            <!-- 友情提示 -->
            <div class="tips">"我在培考通看中了商品，快帮我付款吧!"</div>
        </div>
    </div>
    <!-- 店铺及商品名称 -->
    <div class="shop-goods-content">
        <div class="shop-nick">{{datas.shopName}}的店铺</div>
        <div class="goods-name">《{{datas.productName}}》</div>
    </div>
    <!-- 中间线 -->
    <!-- <div class="center-line"></div> -->
    <!-- 待付款二维码 -->
    <div class="pay-for-content">
        <!-- 代付金额 -->
        <div class="pay-for-money">
            <div class="pay-for-money-text">代付金额:</div>
            <div class="pay-for-money-price-con">
                <div class="pay-for-money-before">￥</div>
                <div class="pay-for-money-price">{{this.$route.query.payPrice}}</div> 
            </div>
        </div>
        <!-- 二维码 -->
        <div class="erweima">
            <img :src="qrcode" alt="">
            <!-- <vue-qr :text="qrcode" :size="200"></vue-qr> -->
        </div>
        <div class="pay-for-tips">
            <div class="tips-con">该二维码<span class="expiration-time">{{datas.expireTime}}</span>前有效</div>
            <div>超时需要重新申请</div>
        </div>
    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
import api from "../../api/api";
import {Toast} from "vant";
export default {
  name: 'payForMe',
  data(){
      return{
          datas:{},
          expirationTime:'2020-09-25',
          userNickName:"巴黎左岸° Provence",
          userPhone:'13956568989',
          shopNick:"青青河边草家政袁小青家政的店铺",
          goodsName:"《母婴护理全课程》",
          payForMoney:'899.00',
          qrcode:'', // 店铺二维码
      }
  },
  methods:{
      changePhoneStyle(){
          this.userPhone = this.userPhone.substring(0,3)+'****'+this.userPhone.substring(7,11)
      },

      //生成二维码
      getQrCode(){
        let params = {
            path:'pages/switch/h5/toH5'+'?page='+'helpPayFor'+'&preOderId='+this.datas.preOrderId
        }
        api.getQrCode(params).then(res=>{
            console.log("code ",res.data)
            this.qrcode = res.data

            //TODO 生成二维码后定时查询订单
            // console.log("preOrderId ",this.datas.preOrderId)
            this.querOrder(this.datas.preOrderId)

        }).catch(err=>{
            console.log("err",err)
        })
      },

      querOrder(preOrderId){
          this.timer = setInterval(()=>{
             let da = {
                 id:preOrderId
             }

              api.getPreOrderMsg(da).then(res=>{
                if (res.success){
                    // console.log("查询结果 ", res.data)
                    let orderStatus = res.data.status;
                    // console.log("支付状态 ",orderStatus)
                    if (orderStatus === 'paid'){ //已支付
                        clearInterval(this.timer)
                        this.$router.push({
                            path: "/payForSuccess",
                            query: {},
                        });
                        return
                    }else if(orderStatus === 'expired'){ //已过时 跳转超时页面
                        this.$router.push({
                            path: "/helpPayForFaile",
                            query: {},
                        });
                    }
                }else {
                    return Toast(res.message);
                }
              }).catch(err=>{
                  console.log("err",err)
              })

          },1000)
      }
  },
  created(){
      document.title = "帮我付款";
      console.log("query ",this.$route.query)
      this.datas=this.$route.query;
      this.userPhone=this.datas.phone;
      this.getQrCode();
  },
  mounted(){
      this.changePhoneStyle()
  },
  components:{
        vueQr
    },
    beforeDestroy() {
        clearInterval(this.timer)
    }
}
</script>
<style lang="scss" scoped>
    body{
        margin:0;
        padding:0;
    }
    .payForMe{
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: url('../../assets/images/bg@2x.png') no-repeat!important;
        // 顶部用户信息
        .top-con{
            // width: 100%;
            display: flex;
            .user-img{
                margin:18px 5% 24px 5%;
                width: 40px;
                height: 40px;
                border-radius: 20px;
                img{
                    width: 40px;
                    height: 40px;
                    border-radius: 20px;
                }
            }
            .user-message{
                margin:18px 15px 16px 0px;
                display: flex;
                flex-direction: column;
                .user-nickName-phone{
                    display: flex;
                    // align-items: center;
                    .nickName{
                        max-width: 160px;
                        height: 22px;
                        font-size: 16px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 22px;
                        text-align-last: left;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
                    .phone{
                        width: 138px;
                        height: 22px;
                        font-size: 16px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 22px;
                        text-align: left;
                        margin-left: 5px;
                    }   
                }
                // 友情提示
                .tips{
                    margin-top:6px;
                    width: 284px;
                    height: 20px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 20px;
                    text-align-last: left;
                }
            }
        }
        // 店铺及商品名称
        .shop-goods-content{
            width: 90%;
            height: 97px;
            // background: #FFEFEF;
            background: url('../../assets/images/top-bg.png') no-repeat;
            background-size: 100% 100%;
            margin: 0 auto;
            .shop-nick{
                // width: 270px;
                height: 20px;
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #590707;
                line-height: 20px;
                margin: 0 auto;
                padding-top:22px;
            }
            .goods-name{
                // width: 163px;
                height: 16px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #590707;
                line-height: 16px;
                margin: 0 auto;
                padding-top:18px;
            }
        }
        // 中间线
        // .center-line{
        //     width: 329px;
        //     // height: 1px;
        //     margin: 0 auto;
        //     border-bottom:1px dashed #FFD8D8;
        // }
        // 待付款二维码
        .pay-for-content{
            width: 90%;
            height: calc(100vh - 200px);
            // background: #FFEFEF;
            background: url('../../assets/images/bottom-bg.png') no-repeat;
            background-size: 100% 100%;
            margin:0 auto;
            // 代付金额
            // .pay-for-money{
            //     width: 183px;
            //     height: 37px;
            //     margin:0 auto;
            //     display: flex;
            //     justify-content: center;
            //     align-items: center;
            //     padding-top:37px;
            //     padding-bottom:27px;
                .pay-for-money-text{
                     height: 22px;
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: bold;
                    color: #F52B23;
                    line-height: 22px;
                    font-weight: bold;
                    padding-top:37px;
                    padding-bottom:5px;
                    margin:0 auto;
                    text-align: center;
                }
                .pay-for-money-price-con{
                    display: flex;
                    justify-content: center;
                    margin:0 auto;
                    width: 100px;
                    height: 37px;
                    padding-bottom:40px;
                    .pay-for-money-before{
                        width: 11px;
                        height: 11px;
                        font-size: 16px;
                        color: #F52B23;
                        padding:10px 6px 0px 0px;
                        font-weight: 600;
                    }
                    .pay-for-money-price{
                        height: 37px;
                        font-size: 26px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: bold;
                        color: #F52B23;
                        line-height: 37px;
                        font-weight: bold;
                    }
                }
            // }
            // 二维码
            .erweima{
                width: 160px;
                height: 160px;
                // background: #000000;
                margin:0 auto;
                img{
                    padding-top:6px;
                    width: 146px;
                    height: 146px;
                    
                }
            }
            .pay-for-tips{
                padding-top:37px;
                margin: 0 auto;
                width: 243px;
                height: 60px;
                color: #666666;
                display: flex;
                flex-direction: column;
                line-height: 30px;
                .tips-con{
                    display: flex;
                    align-items: center;
                    .expiration-time{
                        display: inline-block;
                        width: 116px;
                        height: 24px;
                        background: #F64941;
                        border-radius: 12px;
                        line-height: 26px;  
                        text-align: center;
                        margin: 0px 5px;
                        color: #FFFFFF;
                    }
                }
                
            }
        }
    }
</style>
